<template>
  <div>
    <h2>Applications</h2>

    <p>
      Create and manage your applications. An application is an API Key and associated configuration
      information for accessing the Apptek APIs.  Use different apps to manage reporting or access control.
    </p>

    <table class="table">
      <tr>
        <th>Name</th>
        <th>API key</th>
        <th></th>
        <th>Actions</th>
      </tr>
      <tbody name="fade" is="transition-group">
      <tr v-for="app in apps" :key="app.api_key">
        <td>{{ app.name | truncate(20, '...') }}</td>
        <td class="text-nowrap">
          <code>
            <span class="d-xs-inline d-sm-inline d-md-inline d-lg-none">{{
              app.api_key | truncate(8)
            }}</span>
            <span class="d-xs-none d-sm-none d-md-none d-lg-inline">{{
              app.api_key
            }}</span>
          </code>
          <span v-b-tooltip.hover
                v-b-hover="resetCopyTip"
                :title="copyTip"
                class="clickable ml-2">
                <b-icon icon="subtract"
                @click="updateCopyTip()"
                v-clipboard="app.api_key"></b-icon></span>
        </td>
        <td>
          <b-badge variant="info" v-if="app.is_default === true">default</b-badge>
        </td>
        <td class="text-nowrap">
          <b-button
            v-b-tooltip.hover
            title="Edit"
            variant="secondary"
            size="sm"
            class="p-1 mx-2"
            @click.prevent="$router.push({'name': 'Application', params: { id: app.id } })"
            ><b-icon icon="pencil-square"></b-icon
          ></b-button>
          <b-button
            v-b-tooltip.hover
            title="Delete"
            variant="danger"
            size="sm"
            class="p-1"
            :disabled="app.is_default === true"
            v-b-modal.modal-before-deletem
            @click="selectId(app.id)"
          >
            <b-icon icon="trash"></b-icon>
          </b-button>
        </td>
      </tr>
      </tbody>
    </table>

    <b-modal id="modal-before-delete" hide-footer>
      <div class="mx-5">
        <h4>Are you sure?</h4>
        <p>
          Type "delete" to confirm removing the application and its associated
          data.  The associated API Key will no longer be able to access Apptek services.
        </p>

        <form ref="form">
          <b-form-group>
            <b-form-input v-model="deleteText" @keydown.enter="deleteApp"></b-form-input>
          </b-form-group>

          <p class="mt-4"><b>This action cannot be undone</b></p>

          <b-row>
            <b-col cols="12" class="text-right">
              <b-button
                class="mt-3 mx-3"
                @click="$bvModal.hide('modal-before-delete')"
                >Cancel</b-button
              >
              <b-button
                class="mt-3"
                variant="danger"
                @click="deleteApp"
                :disabled="!confirmedDelete"
                >Delete</b-button
              >
            </b-col>
          </b-row>
        </form>
      </div>
    </b-modal>

    <b-row>
      <b-col cols="12" class="text-right">
        <button
          class="btn btn-primary"
          @click="$router.push('/apps/new')"
        >
          <b-icon icon="plus"></b-icon>
          Create a new application
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_crm.js'

export default {
  data () {
    return {
      deleteText: '',
      selectedId: null,
      copyTip: 'Copy'
    }
  },
  computed: {
    confirmedDelete () {
      return this.deleteText === 'delete'
    },
    apps () {
      return this.$store.state.user.apps
    }
  },
  methods: {
    selectId (id) {
      this.selectedId = id
      this.$bvModal.show('modal-before-delete')
    },
    updateCopyTip () {
      this.copyTip = 'Copied!'
    },
    resetCopyTip () {
      this.copyTip = 'Copy'
    },
    deleteApp () {
      if (this.deleteText !== 'delete') {
        return
      }
      this.$bvModal.hide('modal-before-delete')
      apiClient.delete(`/api/apps/${this.selectedId}`).then((response) => {
        this.alertType = 'success'
        this.alertText = 'Deleted'
        this.alertVisible = true
        this.$store.commit('DELETE_APP', this.selectedId) // Remove from store
        this.deleteText = '' // Clear the modal text
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .8s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.clickable {
  cursor: pointer;
  color: #aaa
}
</style>
